interface ReturnUrlMap {
  [key: string]: string;
}

const returnUrls: ReturnUrlMap = {
  localhost: 'http://localhost:5173/thankyou',
  'santtai.com': 'https://santtai.com/thankyou',
  'santtai.web.app': 'https://santtai.web.app/thankyou',
};

export const getReturnUrl = (
  hostname: string,
  params?: Record<string, string | number | undefined | null>,
): string => {
  const base = returnUrls[hostname] || 'http://localhost:5173/thankyou';
  if (!params) {
    return base;
  }

  const url = new URL(base);
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    url.searchParams.set(key, String(value));
  });
  return url.toString();
};
